import VStack from 'components/atoms/stack/VStack'
import { useScript } from "@uidotdev/usehooks";
import { createElement, forwardRef, memo, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import HelperPlatform from 'utils/helper-platform'
import Ajax from 'utils/request/ajax'
import { configClient } from 'components/provider/ConfigProvider'

const Captcha = forwardRef( ( {}, ref ) => {
	
	const [ key ] = useState( '6LffSlUqAAAAAM8aLqxx7yLufmS3navAIhJuRJ3M' ); // v3
	const [ greCaptchaLoadStatus, setGreCaptchaLoadStatus ] = useState( null );
	
	useImperativeHandle( ref, () => {
		return (
			{
				validate( callback ) {
					// When not web it is always valid!
					if( !HelperPlatform.isWeb() ) {
						callback({ isValid: true });
						return
					}

					// In web we need to validate the captcha
					if( greCaptchaLoadStatus === 'ready' && typeof grecaptcha !== 'undefined' ) {
						grecaptcha.execute( key, { action: 'submit'}).then(function(token) {
							// No token? Invalid!
							if( token.length === 0 ) {
								callback({ isValid: false });
								return
							}

							// Verify with our server
							Ajax.request( configClient.url() + '/connection/rest/captcha/verify', {
								variables: {
									value: token,
								},
								onSuccess: ( result ) => {
									callback({ isValid: result?.status === 'success' });
								},
								onError: ( result ) => {
									callback({ isValid: false });
								},
							});
						});
					} else {
						callback({ isValid: false });
					}
				},
			}
		);
	});
	
	if( !HelperPlatform.isWeb() ) {
		return null;
	}
	
	// Load the script!
	const status = useScript(
		`https://www.google.com/recaptcha/api.js?render=${key}`,
		{
			removeOnUnmount: true,
		}
	);
	
	useEffect( () => {
		setGreCaptchaLoadStatus( status );
	}, [ status ] );
	
	// Return here
	// The functions below this return are for V2
	return null;
	
	const CaptchaDiv = useMemo(() => {
		return memo(props => {
			return createElement('div', props);
		});
	}, []);
	
	return (
		<VStack>
			{ status === 'ready' && (
				<CaptchaDiv
					id={'g-recaptcha'}
					class="g-recaptcha"
					data-sitekey={ key }
				/>
			)}
		</VStack>
	);
})

export default Captcha
